var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.50001L13.5 1.50001M13.5 1.50001H9.49999M13.5 1.50001L7.5 7.5M6.16667 1.5H4.7C3.5799 1.5 3.01984 1.5 2.59202 1.71799C2.21569 1.90973 1.90973 2.21569 1.71799 2.59202C1.5 3.01984 1.5 3.57989 1.5 4.7V10.3C1.5 11.4201 1.5 11.9802 1.71799 12.408C1.90973 12.7843 2.21569 13.0903 2.59202 13.282C3.01984 13.5 3.57989 13.5 4.7 13.5H10.3C11.4201 13.5 11.9802 13.5 12.408 13.282C12.7843 13.0903 13.0903 12.7843 13.282 12.408C13.5 11.9802 13.5 11.4201 13.5 10.3V8.83333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.b4a67985579ef1dc1c5adfad45c438dc.svg";
export { ForwardRef as ReactComponent };